import NextImage, { ImageProps as NextImageProps } from 'next/image';
import { productsLoader } from './loaders/productsLoader';

export type ImageProps = NextImageProps;

export const ProductImage = (props: ImageProps) => {
    return <NextImage loader={productsLoader} {...props} />;
};
